import { getQaSelector } from '../../../../../../utils/common'
import { ICON_HEIGHT_16, IconWithTooltip } from '../../../../../Icon'
import Text from '../../../../../Text'

import * as styles from './ApplicantDecisionStep.module.css'

import InformationIcon from '../../../../../../icons/info.svg'

function ApplicantDecisionStep({ children, hint, label, qaName, step }) {
  return (
    <div
      {...getQaSelector({ value: qaName })}
      className={styles.ApplicantDecisionStep}
    >
      <div className={styles.head}>
        <Text isSecondary className={styles.number}>
          {step}
        </Text>
        <Text isSecondary className={styles.label}>
          {label}
        </Text>
        {hint ? (
          <IconWithTooltip
            Icon={InformationIcon}
            size={ICON_HEIGHT_16}
            svgSize={ICON_HEIGHT_16}
            tooltip={hint}
          />
        ) : null}
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  )
}

export default ApplicantDecisionStep
